import { createRealtimeConnection } from "./connection";
import { subscribeTicketChannels } from "./ticket";
import {
  createChatRoomSubscriptions,
  subscribeChatList,
} from "./chat";

/**
 * Bootstrap one shared realtime session for ticket + chat (+ other domains).
 * Owns connection lifecycle. Domain modules only subscribe/parse.
 *
 * @param {Function} [onEvent]
 * @param {{ abr?: number|string, includeTicketChannels?: boolean }} [options]
 */
export function createRealtimeSession(onEvent, options) {
  options = options || {};
  var abr = options.abr != null && options.abr !== "" ? options.abr : null;
  var includeTicketChannels = options.includeTicketChannels !== false;

  var connection = createRealtimeConnection();
  var chatRooms = createChatRoomSubscriptions(connection, abr);

  if (includeTicketChannels) {
    subscribeTicketChannels(connection);
  }
  subscribeChatList(connection, abr);

  var offEvent =
    typeof onEvent === "function"
      ? connection.on(function (parsed) {
          onEvent(parsed);
        })
      : function () {};

  return {
    disconnect: function () {
      offEvent();
      chatRooms.clear();
      connection.disconnect();
    },
    subscribeChatRoom: chatRooms.subscribeChatRoom,
    unsubscribeChatRoom: chatRooms.unsubscribeChatRoom,
    // Shared transport API for other domains (import, ...)
    subscribe: function (channel) {
      connection.subscribe(channel);
    },
    unsubscribe: function (channel) {
      connection.unsubscribe(channel);
    },
    on: function (fn) {
      return connection.on(fn);
    },
  };
}
